export const MarketingLabelsBriefs = {
  'Promote Products': [
    'This campaign is focused on highlighting selected products to boost their visibility and drive sales.',
    'A promotional push to elevate product visibility and encourage purchase decisions.',
    'The goal is to promote specific items from the catalog through compelling and engaging creatives.',
  ],

  'New Launch': [
    'This campaign is to introduce a new product that has just been launched.',
    'The goal is to inform customers about a newly launched item in the lineup.',
    'A fresh launch campaign meant to create awareness about a new product.',
  ],

  'Feature Highlight': [
    'This campaign focuses on highlighting one key feature or benefit of the product.',
    'The intent is to bring attention to something specific the product offers.',
    'A feature-led message that helps explain why the product is useful or different.',
  ],

  'Price Drop': [
    'This campaign announces a price reduction on an existing product.',
    'The message highlights that the product is now available at a lower price than before.',
    'A value-driven campaign focused on recent price changes or discounts.',
  ],

  'Limited Period Offer': [
    'This is a short-term campaign for a limited-time offer or deal.',
    'The goal is to create urgency around a time-sensitive promotion.',
    'A campaign that communicates a temporary offer valid for only a few days.',
  ],

  'Festive Sale': [
    'This campaign is part of a festive or seasonal promotion with special offers.',
    'The focus is on driving sales during a specific festival or celebration.',
    'A festive campaign that ties into ongoing seasonal shopping moments.',
  ],

  'Weekend Offer': [
    'This is a weekend-only campaign with a special deal valid for a limited time.',
    'The offer runs just for the weekend to drive quick action.',
    'A short burst campaign designed around weekend savings.',
  ],
}
